
window.onload = function () {
    getRem(1920, 100)
};
window.onresize = function () {
    getRem(1920, 100)
};

function getRem(pwidth, prem) {
    var html = document.getElementsByTagName("html")[0];
    var oWidth = window.innerWidth
    // html.style.fontSize = Math.max(50, oWidth / pwidth * prem) + "px";
    html.style.fontSize = `calc(min(var(--max-font-size), max(var(--min-font-size), (${oWidth} / var(--base-width)) * 100px)))`
}
